module.exports = {
  "country": "BG",
  "artist": "Equinox",
  "song": "Bones",
  "year": "2018",
  "place": "14",
  "spotify": "39qWzdNJSioJzfemhwXtDw"
};